import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible';
import common from '@/common/index.js';
import '@/style/theme.css';
import { Toast, Dialog, Notify } from 'vant';
import api from '@/api';
import { ConfigProvider } from 'vant';

const app = createApp(App);
router.beforeEach((to,from)=>{
    console.log(to,'to')
    if(to.meta.title){
        document.title = to.meta.title
    }
    return true
})
app.config.globalProperties.$http = api

app.use(store).use(router).use(common).use(Toast).use(Dialog).use(Notify).use(ConfigProvider).mount('#app')
